import React from 'react'
import styles from '../AdminPanelPage.module.scss'
import MiniMap from 'pages/ReportCard/MiniMap'

const BranchesList = ({ base, baseType = 'ТОП-базы', branches = [], branchesFilter = '', setBranchesFilter = () => {}, openCreateModal, loadBranchesByBasePage = () => {}, editingBranch, editPayloads = {}, setEditPayloads = () => {}, startEdit = () => {}, saveEdit = () => {}, cancelEdit = () => {}, branchesPagination = {} }) => {
  const getBaseKey = (type) => {
    if (type === 'ТОП-базы') return 'top_base'
    if (type === 'ТЭЦ') return 'chpp'
    if (type === 'Соц. Объекты и МСУ' || type === 'privatepoint') return 'private_point'
    return 'top_base'
  }
  const getBaseLabel = (type) => {
    if (type === 'ТОП-базы') return 'ТОП-базы'
    if (type === 'ТЭЦ') return 'ТЭЦ'
    if (type === 'Соц. Объекты и МСУ' || type === 'privatepoint') return 'Соц.объекта или МСУ'
    return 'базы'
  }
  const baseKey = getBaseKey(baseType)
  const baseLabel = getBaseLabel(baseType)
  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <strong>Филиалы этого {baseLabel}</strong>
        <div>
                  <button className="btn btn-primary" onClick={() => openCreateModal('branch', { [baseKey]: base.id, [`${baseKey}_name`]: base.name })}>
          Создать филиал
        </button>
        </div>
      </div>
      <div style={{ marginTop: 8 }}>
        <div className={styles.searchRow}>
          <input className={styles.searchInput} placeholder="Поиск..." value={branchesFilter || ''} onChange={(e) => setBranchesFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadBranchesByBasePage(base.id, 1, branchesFilter || '') }} />

        </div>
        {(branches && branches.length) ? (
          <>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>№</th>
                  <th>Название</th>
                  <th>Адрес</th>
                  <th>Гео</th>
                  <th>Создано</th>
                  <th>Статус</th>
                  <th>Действия</th>
                </tr>
              </thead>
              <tbody>
                {branches.filter(br => {
                  const q = (branchesFilter || '').toLowerCase()
                  if (!q) return true
                  return (br.name && br.name.toLowerCase().includes(q)) || (br.address && br.address.toLowerCase().includes(q))
                }).map((br, index) => (
                  <React.Fragment key={br.id}>
                    <tr>
                      <td>{index + 1}</td>
                      <td>{br.name}</td>
                      <td>{br.address || '-'}</td>
                      <td>
                        {br.geo ? (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <button 
                                onClick={() => window.open(`https://www.google.com/maps?q=${br.geo}`, '_blank')} 
                                className={styles.geoLinkBtn}
                                title="Открыть в Google Maps"
                              >
                                🗺️ Карты
                              </button>
                              <button 
                                onClick={() => {
                                  const elem = document.getElementById(`map-branch-${br.id}`);
                                  if (elem) elem.style.display = elem.style.display === 'none' ? 'block' : 'none';
                                }} 
                                className={styles.mapToggleBtn}
                                title="Показать/скрыть карту"
                              >
                                📌
                              </button>
                            </div>
                            <div id={`map-branch-${br.id}`} style={{ width: 200, height: 150, display: 'none' }}>
                              <MiniMap geo={br.geo} />
                            </div>
                          </div>
                        ) : '-'}
                      </td>
                      <td>{br.created_at}</td>
                      <td>{br.is_active ? 'Активен' : 'Неактивен'}</td>
                      <td>
                        <button className={styles.smallBtn} onClick={() => startEdit('branch', { [baseKey]: base.id, brId: br.id }, { name: br.name, address: br.address, geo: br.geo, is_active: br.is_active })}>Изменить</button>
                      </td>
                    </tr>
                    {editingBranch && editingBranch[base.id] === br.id && (
                      <tr>
                        <td colSpan={7}>
                          <div style={{ padding: 8 }}>
                            <label>Название</label>
                            <input value={(editPayloads[`branch_${base.id}_${br.id}`] || {}).name || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`branch_${base.id}_${br.id}`]: { ...p[`branch_${base.id}_${br.id}`], name: e.target.value } }))} />
                            <label style={{ marginLeft: 8 }}>Адрес</label>
                            <input value={(editPayloads[`branch_${base.id}_${br.id}`] || {}).address || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`branch_${base.id}_${br.id}`]: { ...p[`branch_${base.id}_${br.id}`], address: e.target.value } }))} />
                            <label style={{ marginLeft: 8 }}>Гео</label>
                            <input value={(editPayloads[`branch_${base.id}_${br.id}`] || {}).geo || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`branch_${base.id}_${br.id}`]: { ...p[`branch_${base.id}_${br.id}`], geo: e.target.value } }))} />
                            <label style={{ marginLeft: 8 }}>Активен</label>
                            <input type="checkbox" checked={(editPayloads[`branch_${base.id}_${br.id}`] || {}).is_active || false} onChange={(e) => setEditPayloads(p => ({ ...p, [`branch_${base.id}_${br.id}`]: { ...p[`branch_${base.id}_${br.id}`], is_active: e.target.checked } }))} />
                            <div style={{ marginTop: 8 }}>
                              <button className={styles.btn_pin} onClick={() => saveEdit('branch', { [baseKey]: base.id, brId: br.id })}>Сохранить</button>
                              <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('branch', { [baseKey]: base.id })}>Отмена</button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            {(!branchesFilter && branchesPagination && branchesPagination.count > 0) && (
              <div className={styles.pagination}>
                <button disabled={!branchesPagination.previous} onClick={() => loadBranchesByBasePage(base.id, (branchesPagination.page || 1) - 1)}>Пред.</button>
                <span>Стр. {branchesPagination.page || 1} — Всего: {branchesPagination.count}</span>
                <button disabled={!branchesPagination.next} onClick={() => loadBranchesByBasePage(base.id, (branchesPagination.page || 1) + 1)}>След.</button>
              </div>
            )}
          </>
        ) : (
          <div>Филиалы не найдены</div>
        )}
      </div>
    </div>
  )
}

export default BranchesList